import CollapsibleCategoryButtons from 'lib/CollapsibleCategory/CollapsibleCategoryButtons';
import { FileList } from 'components/common/types';
import ExpandableFilesList from './ExpandableFilesList';
import FlatFilesList from './FlatFilesList';
import { ListOfFilesProps } from './ListOfFiles.types';

const createDefaultRenderHeaderComponent =
  (onRemoveFile?: (name: string) => void) =>
  (file: FileList, _fileIndex: number, isHovered: boolean): React.ReactElement | null => {
    const { name } = file;

    return isHovered && onRemoveFile ? <CollapsibleCategoryButtons onRemove={() => onRemoveFile?.(name)} /> : null;
  };

const ListOfFiles = ({
  uploadedFiles,
  shouldExpandFileContents = true,
  onRemoveFile,
  onToggleCategory,
  openCategories = [],
  renderItem,
  renderHeaderComponent,
  onDownloadFile,
}: ListOfFilesProps): React.ReactElement => {
  if (!shouldExpandFileContents) {
    const defaultHeader = createDefaultRenderHeaderComponent(onRemoveFile);

    return (
      <FlatFilesList
        uploadedFiles={uploadedFiles}
        renderHeaderComponent={defaultHeader}
        onDownloadFile={onDownloadFile}
      />
    );
  }

  return (
    <ExpandableFilesList
      uploadedListOfFiles={uploadedFiles}
      onToggleCategory={onToggleCategory!}
      openCategories={openCategories}
      renderItem={renderItem!}
      renderHeaderComponent={renderHeaderComponent!}
    />
  );
};

export default ListOfFiles;
